"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = void 0;
const blue = {
    100: "#162D5B",
    90: "#143987",
    80: "#0641BD",
    70: "#064FDA",
    60: "#105DEC",
    50: "#196CFF",
    40: "#4085FE",
    30: "#6AA0FE",
    20: "#8CB5FE",
    10: "#BED4FC",
    0: "#ECF2FE",
};
exports.default = blue;
//# sourceMappingURL=blue.js.map